<template>
  <modal-ui :visible="visible" @close="closeModal" title="Додати відгук">
    <p class="field-name" style="margin-top: 20px">Автор відгуку</p>
    <v-text-field
      v-model="review.client_name"
      outlined
      dense
      placeholder="Введіть автора"
      :error-messages="client_nameError"
      hide-details
    />
    <p class="field-name" style="margin-top: 20px">Текст відгуку</p>
    <v-textarea
      v-model="review.text"
      outlined
      dense
      placeholder="Введіть техт"
      :error-messages="textError"
      hide-details
    />
    <v-row no-gutters style="margin-top: 20px">
      <admin-cancel-btn
        height="38px"
        @click="$emit('close')"
        width="calc(50% - 6px)"
        style="margin-right: 12px"
        >Скасувати</admin-cancel-btn
      >
      <admin-submit-button
        v-if="isEdit"
        height="38px"
        width="calc(50% - 6px)"
        :loading="isLoadingBtn"
        @click="updateReview"
        >Зберегти</admin-submit-button
      >
      <admin-submit-button
        v-else
        height="38px"
        width="calc(50% - 6px)"
        :loading="isLoadingBtn"
        @click="createReview"
        >Додати відгук</admin-submit-button
      >
    </v-row>
  </modal-ui>
</template>

<script>
import modalUi from "@/components/UI/Modals/modalUI.vue";
import AdminSubmitButton from "../../UI/Btns/adminSubmitButton.vue";
import { validationMixin } from "vuelidate";
import AdminCancelBtn from "../../UI/Btns/adminCancelBtn.vue";
import { required } from "vuelidate/lib/validators";
import reviewService from "../../../requests/Admin/reviewService";
export default {
  mixins: [validationMixin],
  components: {
    modalUi,
    AdminSubmitButton,
    AdminCancelBtn,
  },
  data: () => ({
    review: {
      client_name: "",
      text: "",
    },
  }),
  props: {
    visible: {
      default: false,
    },
    isEdit: {
      require: false,
    },
    itemForEdit: {
      require: false,
    },
  },
  validations: {
    review: {
      client_name: {
        required,
      },
      text: {
        required,
      },
    },
  },
  mounted() {
    if (this.isEdit) {
      this.review = this.itemForEdit;
    }
  },
  methods: {
    async createReview() {
      this.$v.review.$touch();
      if (!this.$v.review.$invalid) {
        this.isLoadingBtn = true;
        const form = new FormData();
        form.append("client_name", this.review.client_name);
        form.append("text", this.review.text);
        await reviewService
          .createReview(form)
          .then(() => {
            this.$emit("success", "Відгук додано");
            this.closeModal();
          })
          .catch(() => {
            this.isLoadingBtn = true;
          });
      }
    },
    async updateReview() {
      this.$v.review.$touch();
      if (!this.$v.review.$invalid) {
        this.isLoadingBtn = true;
        const form = new FormData();
        form.append("client_name", this.review.client_name);
        form.append("text", this.review.text);
        await reviewService
          .updateReview(this.review.id, form)
          .then(() => {
            this.$emit("success", "Відгук оновлено");
            this.closeModal();
          })
          .catch(() => {
            this.isLoadingBtn = true;
          });
      }
    },
    closeModal() {
      this.$emit("close");
    },
    addPoint() {
      this.review.points.push({
        id: Date.now(),
        description: "",
      });
    },
  },
  computed: {
    client_nameError() {
      const errors = [];
      if (
        this.$v.review.client_name.$dirty &&
        !this.$v.review.client_name.required
      ) {
        errors.push("");
      }
      return errors;
    },

    textError() {
      const errors = [];
      if (this.$v.review.text.$dirty && !this.$v.review.text.required) {
        errors.push("");
      }
      return errors;
    },
  },
};
</script>

<style scoped>
.drop-zone {
  width: 100%;
  height: 295px;
  border-radius: 4px;
  border: 1px dashed #e4e4e7;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-top: 26px;
  color: #000;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
}
</style>